import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

import zuzLogo from '../../assets/images/zuz-logo-filled-text.png';
import zuzLogoFilledNo from '../../assets/images/zuz-logo-filled-no.png';
import netOverlay from '../../assets/images/net-overlay.png';
import pyramid from '../../assets/images/pyramid.png';
import funnel from '../../assets/images/geyser-glow.png';
import Ethereum from '../../assets/images/ethereum.png';
import MetaMask from '../../assets/images/meta-mask.png';
import ChainCircle, { RightArrow, RefreshLogo } from '../Svg/index';

import styles from './stylesheets/GuestUser.module.css';
import TokenStats from './TokenStats';
import GuestUserHeader from "./GuestUserHeader";
import GuestUserFooter from "./GuestUserFooter";


export class GuestUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isRegisteredUser: false,
        }
    }

    render() {
        return (
            <div className={styles.guestUser}>
               
                <div className={styles.guestUserBody}>
                    <GuestUserHeader></GuestUserHeader>
                    <TokenStats isRegisteredUser={this.state.isRegisteredUser}></TokenStats>
                </div>
                {
                    this.state.isRegisteredUser ?
                        null
                        :
                        <div className={styles.joinUsBtnCont}>
                            <div className={styles.joinUsBtn}>
                                <div className={styles.arrowCont}>
                                    <RightArrow></RightArrow>
                                </div>
                                <div className={styles.joinNowPara}>
                                    <p>JOIN NOW</p>
                                </div>
                            </div>
                        </div>
                }
                <GuestUserFooter></GuestUserFooter>
            </div>
        )
    }
}






export default GuestUser
